import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShoppingBag, ArrowUpRight } from "lucide-react";

export const ShopCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/shop/products?limit=4").then((r) => setData(r.data)).catch(() => setData({ shop_url: "", products: [] }));
  }, []);

  if (!data) return null;
  const { shop_url, products } = data;

  return (
    <section data-testid="shop-cta">
      <div className="flex items-end justify-between gap-4 mb-5 flex-wrap">
        <div>
          <p className="eyebrow" style={{ color: "#FF0055" }}>Wear the rebuild</p>
          <h2 className="font-display font-black text-2xl md:text-3xl mt-1">CINDR // <span style={{ color: "#FF0055" }}>ESSENTIALS</span></h2>
        </div>
        <a href={shop_url} target="_blank" rel="noopener noreferrer" className="btn-primary flex items-center gap-2" data-testid="shop-link">
          <ShoppingBag size={14} /> Shop all
        </a>
      </div>

      {products.length === 0 ? (
        <div className="card text-sm text-zinc-400" data-testid="shop-empty">Store is restocking. Tap “Shop all” to browse.</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 stagger" data-testid="shop-products">
          {products.map((p) => (
            <a key={p.id} href={p.url} target="_blank" rel="noopener noreferrer" className="card card-interactive p-0 overflow-hidden group flex flex-col" data-testid={`shop-product-${p.id}`}>
              <div className="relative aspect-square overflow-hidden" style={{ background: "#FFFFFF" }}>
                <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105" />
                {!p.available && (
                  <span className="absolute top-2 left-2 text-[9px] font-bold uppercase tracking-widest px-2 py-1" style={{ background: "#0A0A0A", color: "#a1a1aa" }}>Sold out</span>
                )}
                <span className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" style={{ background: "#FF0055" }}>
                  <ArrowUpRight size={14} color="white" />
                </span>
              </div>
              <div className="p-3 flex-1 flex flex-col">
                {p.type && <p className="eyebrow text-[9px]">{p.type}</p>}
                <p className="font-display font-bold uppercase text-xs md:text-sm mt-1 leading-tight line-clamp-2">{p.title}</p>
                <p className="font-display font-black mt-auto pt-2" style={{ color: "#FF0055" }}>{p.price !== null ? `$${p.price.toFixed(2)} ${p.currency}` : "—"}</p>
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};
